import {
    FormControl,
    FormControlProps,
    FormLabel,
    TextField,
    TextFieldProps,
} from '@mui/material'
import { ReactNode } from 'react'
import { Control, Controller, FieldValues, Path } from 'react-hook-form'

type FormInputProps<T extends FieldValues> = {
    name: Path<T>
    control: Control<T>

    readOnly?: boolean
    formLabel?: ReactNode
    formHelperText?: ReactNode
    textFieldProps?: TextFieldProps
    formControlProps?: Partial<FormControlProps>
}
const FormInputText_v2 = <T extends FieldValues>({
    name,
    control,
    textFieldProps,
    formControlProps,
    formLabel,
    formHelperText,
    readOnly = false,
}: FormInputProps<T>) => {
    return (
        <Controller
            name={name}
            control={control}
            render={(renderProps) => (
                <FormControl
                    {...formControlProps}
                    error={!!renderProps.fieldState.error}
                >
                    {formLabel ? (
                        <FormLabel sx={{ mb: 1.5 }}>{formLabel}</FormLabel>
                    ) : null}
                    <TextField
                        {...textFieldProps}
                        name={name}
                        onChange={renderProps.field.onChange}
                        value={renderProps.field.value || ''}
                        error={!!renderProps.fieldState.error}
                        helperText={renderProps.fieldState.error?.message}
                        fullWidth
                        variant={textFieldProps?.variant || 'outlined'}
                        slotProps={{
                            ...textFieldProps?.slotProps,
                            input: {
                                ...textFieldProps?.slotProps?.input,
                                readOnly,
                            },
                        }}
                    />
                    {formHelperText}
                </FormControl>
            )}
        />
    )
}

export default FormInputText_v2
